import React from "react";
import logo from '../assets/logo.png'; // Apna logo yahan import karein
import { useNavigate } from "react-router-dom";
import { 
  ShieldCheck, Truck, Users, Settings, Factory, Globe, 
  CheckCircle2, BarChart3, Microscope, Handshake, 
  Award, Zap, Search, Box, HeadphonesIcon,
  ArrowRight, HeartPulse, HardHat, Cpu, Database,
  TrendingUp, Briefcase // <-- In dono ko add kar diya hai, ab error nahi aayega
} from "lucide-react"; 

const AboutUs: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <div className="bg-white text-slate-900 font-sans selection:bg-blue-100">
      
{/* 1. HERO SECTION - SINGLE LINE HEADING VERSION */}
<section className="relative min-h-screen flex items-center bg-white overflow-hidden pt-20 pb-12">
  
  {/* Background Decor */}
  <div className="absolute top-0 right-0 w-[45%] h-full bg-[#f8fafc] -skew-x-6 translate-x-12 z-0 hidden lg:block"></div>
  <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#2e3192]/5 blur-[120px] rounded-full"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center w-full">
    
    {/* Left Side: Content (7 Columns) */}
    <div className="lg:col-span-7 space-y-8 animate-fade-in">
      
      {/* Heading Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-4 mb-2">
          <div className="h-[1px] w-10 bg-slate-200"></div>
          <p className="text-slate-400 text-lg font-light tracking-[0.3em] uppercase">The Engine of</p>
        </div>
        
        {/* TRADY FROG ab ek hi line mein hai aur size perfectly adjusted hai */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#2e3192] leading-tight tracking-tighter uppercase whitespace-nowrap">
          Trady <span className="text-[#008b7a]">Frog.</span>
        </h1>
      </div>
      
      {/* Your Full Content */}
      <div className="space-y-6 max-w-xl">
        <h3 className="text-2xl font-bold text-slate-800 leading-tight">
          Making Indian MSMEs Digitally Saksham
        </h3>
        
        <p className="text-lg text-slate-600 leading-relaxed text-justify">
          We are one of <strong>India’s largest and oldest B2B e-commerce platforms</strong> that
          connects buyers and suppliers to create a customer-driven value chain for
          all businesses, including SMEs, large enterprises, and individuals.
        </p>

        <p className="text-lg text-slate-600 leading-relaxed text-justify">
          We integrate businesses into global value chains by bringing them together
          from across the world, on a single platform to interact and conduct the
          business smoothly, securely, and effectively.
        </p>
      </div>

      {/* Buttons */}
      <div className="flex flex-wrap gap-5 pt-4">
        <button 
          onClick={() => handleNavigation('/products')}
          className="bg-[#2e3192] text-white px-10 py-5 rounded-2xl font-bold text-lg hover:bg-[#1e206b] transition-all shadow-xl active:scale-95 flex items-center gap-4 group"
        >
          Explore Market <ArrowRight size={22} className="group-hover:translate-x-2 transition-transform" />
        </button>
        <button 
          onClick={() => handleNavigation('/contact')}
          className="bg-white border-2 border-slate-100 text-slate-600 hover:border-[#2e3192] px-10 py-5 rounded-2xl font-bold text-lg transition-all active:scale-95 shadow-sm"
        >
          View Catalog
        </button>
      </div>
    </div>

    {/* Right Side: Image Placeholders (5 Columns) */}
    <div className="lg:col-span-5 relative flex justify-center lg:justify-end">
      
      <div className="relative w-full max-w-[450px]">
        
        {/* MAIN IMAGE LINK PLACEHOLDER */}
        <div className="relative z-10 aspect-square rounded-[4rem] overflow-hidden border-[12px] border-white shadow-2xl bg-slate-100 group">
           <img 
              src="https://png.pngtree.com/thumb_back/fh260/background/20260106/pngtree-diverse-business-people-in-modern-office-space-setting-image_21023009.webp" // <-- APNI MAIN IMAGE KA LINK YAHAN DALO
              alt="Industrial Tech" 
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" 
              onError={(e) => { e.currentTarget.src = "https://via.placeholder.com/800x800?text=MAIN+IMAGE+LINK"; }}
           />
        </div>

        {/* TOP MINI IMAGE LINK PLACEHOLDER */}
        <div className="absolute -top-10 -left-10 z-20 w-40 h-40 rounded-[2.5rem] overflow-hidden border-8 border-white shadow-2xl bg-slate-200 hidden md:block">
           <img 
              src="https://www.automationindiaexpo.com/img/contact-bg.jpg" // <-- APNI CHOTI IMAGE KA LINK YAHAN DALO
              alt="Digital Trade" 
              className="w-full h-full object-cover"
              onError={(e) => { e.currentTarget.src = "https://via.placeholder.com/300x300?text=SMALL+IMAGE"; }}
           />
        </div>

        {/* Global Access Badge */}
        <div className="absolute -bottom-6 right-6 z-30 bg-white px-8 py-5 rounded-3xl shadow-2xl border border-slate-50 flex items-center gap-4">
          <div className="bg-[#008b7a]/10 p-3 rounded-xl text-[#008b7a]">
            <Globe size={28} />
          </div>
          <div>
            <p className="text-xl font-black text-slate-900 leading-none">Global</p>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1">Value Chain</p>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>
{/* 2. NUMBERS SECTION - UPDATED DESIGN (NO DOT) */}
<section className="py-16 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto px-6">
    <div className="flex flex-wrap lg:flex-nowrap items-center justify-between gap-8">
      
      {/* Left Intro Text */}
      <div className="lg:w-1/4 mb-8 lg:mb-0">
        <h4 className="text-[#2e3192] text-sm font-black uppercase tracking-[0.3em] mb-2">Our Impact</h4>
        <p className="text-slate-400 text-xs font-medium leading-relaxed">
          Driving digital transformation across the Indian industrial landscape.
        </p>
      </div>

      {/* The Osm Number Strips */}
      <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-4 w-full">
        {[
          { label: "Active Suppliers", val: "2,400+", icon: <Factory size={18} />, delay: "0" },
          { label: "Products Catalog", val: "45,000+", icon: <Box size={18} />, delay: "100" },
          { label: "Annual Shipments", val: "1.2M+", icon: <Truck size={18} />, delay: "200" },
          { label: "Global Reach", val: "18+ Countries", icon: <Globe size={18} />, delay: "300" }
        ].map((stat, i) => (
          <div 
            key={i} 
            className="group relative bg-[#f8fafc] hover:bg-[#2e3192] p-8 rounded-[2.5rem] transition-all duration-500 ease-in-out flex flex-col items-center text-center shadow-sm hover:shadow-2xl hover:-translate-y-4"
          >
            {/* Moving Icon */}
            <div className="mb-4 text-[#008b7a] group-hover:text-white transition-colors duration-300 group-hover:scale-125 group-hover:-rotate-12 transform">
              {stat.icon}
            </div>

            {/* Compact Number */}
            <div className="relative">
              <p className="text-3xl font-black text-[#2e3192] group-hover:text-white tracking-tighter transition-colors">
                {stat.val}
              </p>
              
              {/* --- DOT REMOVED AND REPLACED WITH A STYLISH LINE --- */}
              <div className="w-8 h-[2px] bg-[#008b7a]/30 mx-auto mt-2 group-hover:bg-white/40 group-hover:w-12 transition-all duration-500"></div>
            </div>

            {/* Label */}
            <p className="mt-4 text-[9px] font-bold text-slate-400 group-hover:text-white/70 uppercase tracking-widest leading-none">
              {stat.label}
            </p>

            {/* Decorative Corner Light Effect */}
            <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-tr-[2.5rem]"></div>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

{/* 3. HOW WE DO IT - FINAL VERSION (IndiaMART Style + Custom Typography) */}
<section className="py-24 px-6 bg-[#f8fafc] overflow-hidden">
  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
    
    {/* Left Side: Circular Ecosystem */}
    <div className="relative flex items-center justify-center min-h-[600px] order-2 lg:order-1">
      
      {/* Background Rings */}
      <div className="absolute w-[450px] h-[450px] border border-blue-100 rounded-full opacity-50"></div>
      <div className="absolute w-[380px] h-[380px] border-2 border-dashed border-blue-200 rounded-full animate-spin-slow"></div>

      {/* Main Navy Blue Circle */}
      <div className="relative w-[300px] h-[300px] md:w-[320px] md:h-[320px] bg-[#2e3192] rounded-full flex items-center justify-center shadow-[0_20px_50px_rgba(46,49,146,0.3)] border-[8px] border-white">
        
        {/* Animated Inner Ring */}
        <div className="absolute inset-4 border-2 border-white/20 rounded-full border-t-white animate-spin"></div>

        {/* --- COMPANY LOGO AREA --- */}
        <div className="absolute z-20 w-[115px] h-[115px] md:w-[130px] md:h-[130px] bg-white rounded-full flex items-center justify-center shadow-inner p-3 overflow-hidden border border-slate-100">
           <img 
              // APNA LOGO YAHAN LAGAYEIN:
              // Agar logo public folder mein hai to "/logo.png" likhein
              // Agar assets folder mein hai to pehle import karein phir src={logoVariable} likhein
              src={logo} 
              alt="Trady Frog Logo" 
              className="w-full h-full object-contain"
              onError={(e) => {
                // Agar logo load nahi hua to ye text dikhega
                e.currentTarget.src = "https://via.placeholder.com/150?text=TRADY+FROG"; 
              }}
           />
        </div>
        {/* ------------------------- */}

        {/* Trady-Frog Style Labels (Top) */}
        <div className="absolute -top-16 -left-8 flex flex-col items-center group">
          <div className="bg-white p-3 rounded-xl shadow-md border border-slate-100 mb-2 group-hover:-translate-y-1 transition-transform">
            <Briefcase className="text-[#2e3192]" size={24} />
          </div>
          <span className="text-[10px] font-black text-slate-400 tracking-[0.2em]">BUYERS</span>
        </div>

        <div className="absolute -top-16 -right-8 flex flex-col items-center group">
          <div className="bg-white p-3 rounded-xl shadow-md border border-slate-100 mb-2 group-hover:-translate-y-1 transition-transform">
            <Factory className="text-[#2e3192]" size={24} />
          </div>
          <span className="text-[10px] font-black text-slate-400 tracking-[0.2em]">SUPPLIERS</span>
        </div>

        {/* Orbital Icons */}
        <div className="absolute inset-0">
          {[
            { Icon: Search, pos: "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" },
            { Icon: ShieldCheck, pos: "top-1/4 -right-12" },
            { Icon: TrendingUp, pos: "bottom-1/4 -right-12" },
            { Icon: Box, pos: "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2" },
            { Icon: Globe, pos: "bottom-1/4 -left-12" },
            { Icon: HeadphonesIcon, pos: "top-1/4 -left-12" }
          ].map((item, idx) => (
            <div 
              key={idx} 
              className={`absolute ${item.pos} w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg border border-white text-[#2e3192] hover:bg-[#2e3192] hover:text-white transition-all cursor-pointer z-30`}
            >
              <item.Icon size={18} />
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Right Side: Content */}
    <div className="order-1 lg:order-2 lg:pl-12">
      <div className="mb-10">
        {/* <h2 className="text-slate-400 text-xl font-light tracking-[0.3em] uppercase mb-2">Process</h2> */}
        <div className="flex flex-col">
          <span className="text-slate-700 text-3xl font-light">HOW</span>
          <span className="text-[#2e3192] text-6xl font-black tracking-tighter leading-none">WE DO IT</span>
        </div>
        <div className="w-24 h-2 bg-[#008b7a] mt-6 rounded-full"></div>
      </div>

      <div className="space-y-6">
        <p className="text-xl text-slate-700 font-medium leading-relaxed italic border-l-4 border-[#008b7a] pl-6">
          "We believe in empowering businesses with tech-powered solutions."
        </p>
        
        <div className="space-y-4 text-slate-500 leading-relaxed text-justify">
          <p>
            Trady Frog stands at the forefront of industrial digital transformation. Our innovative tools ensure quick and responsive connections between suppliers and buyers, thanks to our unique, data-driven algorithmic matchmaking. This enables us to deliver tailored services that meet the specific needs of each business.
          </p>
          <p>
            By continually investing in AI, ML, and big data analytics, we aim to improve the entire procurement lifecycle. From automated lead management to voice-assisted search and deep-tier logistics tracking, we ensure a seamless user experience that promotes ease of doing business across borders.
          </p>
          <p>
            Our ecosystem is built on transparency and trust. Every supplier on our platform undergoes a rigorous 12-point verification process, ensuring that buyers receive only the highest quality industrial goods. We are not just a marketplace; we are your strategic partner in growth.
          </p>
        </div>

        <div className="pt-6">
          <button 
            onClick={() => handleNavigation('/achievements')}
            className="group relative px-8 py-4 bg-[#008b7a] text-white overflow-hidden rounded-lg font-bold transition-all shadow-xl hover:shadow-[#008b7a]/40 active:scale-95 flex items-center gap-3"
          >
            <span className="relative z-10 uppercase tracking-widest text-xs">Our Success Milestones</span>
            <ArrowRight size={18} className="relative z-10 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
{/* --- UNIQUE HISTORY SECTION START --- */}
<section className="py-24 px-6 bg-white relative overflow-hidden">
  {/* Background Decorative Element */}
  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-[0.03] pointer-events-none flex justify-center items-center">
    <h2 className="text-[20rem] font-black text-slate-900 leading-none select-none">EST 1996</h2>
  </div>

  <div className="max-w-7xl mx-auto relative z-10">
    <div className="text-center mb-20">
      <h4 className="text-[#008b7a] text-sm font-black uppercase tracking-[0.4em] mb-4">The Journey</h4>
      <h2 className="text-5xl md:text-7xl font-black text-[#2e3192] tracking-tighter">OUR <span className="text-slate-200">HISTORY</span></h2>
      <div className="w-20 h-2 bg-[#2e3192] mx-auto mt-6 rounded-full"></div>
    </div>

    <div className="relative border-l-2 border-dashed border-slate-200 ml-4 md:ml-0 md:flex md:flex-col md:items-center md:border-l-0">
      
      {/* Timeline Line (Desktop Only) */}
      <div className="hidden md:block absolute left-1/2 -translate-x-1/2 h-full w-[2px] bg-gradient-to-b from-[#2e3192] via-[#008b7a] to-transparent"></div>

      {/* 1996 - The Origin */}
      <div className="relative mb-20 md:w-full">
        <div className="md:flex items-center justify-between">
          <div className="md:w-[45%] mb-8 md:mb-0">
            <div className="bg-[#f8fafc] p-8 rounded-[3rem] border border-slate-100 shadow-xl hover:shadow-2xl transition-all group">
              <span className="text-6xl font-black text-[#2e3192]/10 group-hover:text-[#2e3192]/20 transition-colors">2015</span>
              <h3 className="text-2xl font-black text-[#2e3192] mt-[-2rem] mb-4">The Spark of Vision</h3>
              <p className="text-slate-600 leading-relaxed italic">
                It all began with Mr. Digvijay Singh simple idea of website development. A journey fueled by a relentless drive to "make doing business easy" for everyone.
              </p>
            </div>
          </div>
          
          <div className="absolute left-[-9px] md:left-1/2 md:-translate-x-1/2 w-4 h-4 bg-[#2e3192] rounded-full ring-8 ring-blue-50"></div>
          
          <div className="md:w-[45%] flex justify-center">
             <div className="relative group">
                <div className="absolute -inset-4 bg-gradient-to-r from-[#2e3192] to-[#008b7a] rounded-[2rem] blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
                <img 
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800" 
                  alt="1996 Team Vision" 
                  className="relative w-64 h-64 object-cover rounded-[2rem] grayscale hover:grayscale-0 transition-all duration-500" 
                />
             </div>
          </div>
        </div>
      </div>

      {/* 1997 - The First Office (Replaced Invitation with Modern Milestone) */}
      <div className="relative mb-20 md:w-full">
        <div className="md:flex items-center justify-between flex-row-reverse">
          <div className="md:w-[45%] mb-8 md:mb-0">
            <div className="bg-slate-900 p-8 rounded-[3rem] shadow-2xl hover:-rotate-2 transition-all group">
              <span className="text-6xl font-black text-white/10 group-hover:text-white/20">2015</span>
              <h3 className="text-2xl font-black text-[#008b7a] mt-[-2rem] mb-4">Physical Foundations</h3>
              <p className="text-slate-400 leading-relaxed">
                Opening ceremony of the first office at Noida, Uttar Pradesh. This wasn't just an office; it was the command center for a digital revolution in Indian MSMEs.
              </p>
            </div>
          </div>
          
          <div className="absolute left-[-9px] md:left-1/2 md:-translate-x-1/2 w-4 h-4 bg-[#008b7a] rounded-full ring-8 ring-teal-50"></div>
          
          <div className="md:w-[45%] flex justify-center">
             <div className="relative p-2 bg-gradient-to-tr from-slate-100 to-white rounded-[2rem] shadow-2xl overflow-hidden group">
                {/* NEW IMAGE: Modern Industrial/Office Archive Feel */}
                <img 
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800" 
                  alt="Modern Office Milestone" 
                  className="w-72 h-48 object-cover rounded-[1.5rem] brightness-90 group-hover:brightness-110 transition-all duration-700" 
                />
                <div className="absolute bottom-4 left-6">
                   <p className="text-[10px] font-black text-white tracking-[0.3em] uppercase drop-shadow-md">Legacy Archive: Noida 2015</p>
                </div>
             </div>
          </div>
        </div>
      </div>

      {/* Evolution Tag */}
      <div className="relative mt-10">
        <div className="bg-gradient-to-r from-[#2e3192] to-[#008b7a] text-white px-8 py-3 rounded-full font-black text-sm tracking-[0.3em] uppercase shadow-lg">
          The Evolution Continues
        </div>
      </div>

    </div>
  </div>
</section>


      {/* 6. VISION QUOTE */}
      <section className="py-24 px-6 bg-slate-50 text-center relative overflow-hidden">
         <div className="max-w-4xl mx-auto relative z-10">
            <h2 className="text-3xl font-bold mb-8 italic text-slate-800 leading-snug">"Our goal is to digitize the industrial backbone of India, making procurement as easy as ordering a meal online."</h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
            <p className="font-bold text-slate-900 uppercase tracking-widest text-sm">Sunil Nayak</p>
            <p className="text-slate-500 text-xs">CEO & Founder, Trady Frog</p>
         </div>
      </section>
{/* 7. ULTRA-PREMIUM LUXURY CTA - REDESIGNED VERSION */}
<section className="py-8 md:py-12 px-6 relative bg-[#fcfcfd] overflow-hidden">
  
  {/* Soft Background Glows */}
  <div className="absolute top-0 left-1/4 w-64 h-64 bg-[#2e3192]/5 rounded-full blur-[100px]"></div>
  <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#008b7a]/5 rounded-full blur-[100px]"></div>

  <div className="max-w-7xl mx-auto relative z-10">
    <div className="bg-white/40 backdrop-blur-2xl rounded-[3.5rem] p-8 md:py-12 md:px-20 border border-white/60 shadow-[0_40px_100px_rgba(0,0,0,0.03)] relative overflow-hidden group">
      
      {/* Decorative Corner Mesh */}
      <div className="absolute -top-24 -right-24 w-48 h-48 bg-gradient-to-br from-[#2e3192]/10 to-transparent rounded-full blur-3xl group-hover:scale-150 transition-transform duration-1000"></div>

      <div className="flex flex-col items-center text-center relative z-20">
        
        {/* Floating Label */}
        <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 bg-white/80 rounded-full shadow-sm border border-slate-100">
          <Zap size={14} className="text-[#008b7a] fill-[#008b7a]" />
          <span className="text-[10px] font-extrabold text-slate-500 uppercase tracking-[0.3em]">Start Your Journey</span>
        </div>

        {/* --- LUXURY HEADING --- */}
        <div className="mb-8">
          <h2 className="text-4xl md:text-[60px] font-black tracking-tight leading-[1.05]">
            <span className="text-[#1d1d1f] block md:inline">Make your move.</span>
            <span className="block md:inline-flex items-center mx-4">
               <div className="hidden md:block w-12 h-[2px] bg-gradient-to-r from-transparent via-slate-300 to-transparent"></div>
            </span>
            <span className="relative inline-block text-transparent bg-clip-text bg-gradient-to-r from-[#2e3192] via-[#008b7a] to-[#2e3192] bg-[length:200%_auto] animate-gradient-x pb-2">
              Build your empire
              <div className="absolute bottom-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#2e3192]/0 via-[#008b7a]/40 to-[#2e3192]/0 rounded-full"></div>
            </span>
          </h2>
        </div>

        <p className="max-w-xl text-base md:text-lg text-slate-500 font-medium leading-relaxed mb-10">
          The most advanced ecosystem for Indian businesses to scale globally. 
          <span className="text-slate-900 font-semibold italic ml-1">Simple. Powerful. Transparent.</span>
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-8">
          <button 
            onClick={() => handleNavigation('/register')}
            className="group relative px-12 py-5 bg-[#1d1d1f] text-white rounded-full font-bold text-lg overflow-hidden transition-all hover:shadow-[0_20px_40px_rgba(46,49,146,0.3)] active:scale-95"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#2e3192] to-[#008b7a] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <span className="relative z-10">Join Trady Frog</span>
          </button>

          <button 
            onClick={() => handleNavigation('/contact')}
            className="flex items-center gap-2 text-lg font-bold text-[#2e3192] hover:text-[#008b7a] transition-colors group/link"
          >
            Learn more
            <ArrowRight size={22} className="group-hover:translate-x-2 transition-transform duration-300" />
          </button>
        </div>

        {/* Feature Icons Section */}
        <div className="mt-12 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-0 border-t border-slate-100 pt-10">
          {[
            { label: 'Secure', sub: 'End-to-End' },
            { label: 'Fast', sub: 'Execution' },
            { label: 'Global', sub: 'Ready' },
            { label: '24/7', sub: 'Support' }
          ].map((item, idx) => (
            <div key={idx} className="flex flex-col items-center border-r last:border-0 border-slate-100/50 px-4">
              <span className="text-xl font-bold text-slate-800">{item.label}</span>
              <span className="text-[9px] font-bold uppercase text-slate-400 tracking-tighter">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* Custom CSS for Shimmer Animation - Add this to your globals.css or a style tag */}
  <style>{`
    @keyframes gradient-x {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .animate-gradient-x {
      animation: gradient-x 5s ease infinite;
    }
  `}</style>
</section>
    </div>
  );
};

export default AboutUs;